import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'epmax-image',
    imports: [CommonModule],
    templateUrl: './image.component.html',
    styleUrl: './image.component.scss'
})

export class ImageComponent {

    @Input('src') src: string = '';
    @Input('class') class: string = '';
    @Input('size') size: string | number = '';
   
}

